export const entryViews = {
  SUPPORT: "/support",
  CONFIRM_MFA: "/confirm-mfa"
};
